require('../../modules/es6.number.is-integer');
module.exports = require('../../modules/$.core').Number.isInteger;


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/number/is-integer.js
// module id = 991
// module chunks = 0